import React from "react";
import { t } from "i18next";

const OrderStarRating = ({ totalStars, handleStarClick, rating }) => {
  const starElements = [...Array(totalStars)].map((_, index) => (
    <span
      key={index}
      style={{ fontSize: "50px" }}
      className={index < rating ? "star selected" : "star"}
      onClick={() => handleStarClick(index + 1)}
    >
      ★
    </span>
  ));

  return (
    <div className="horizontal-star-rating cursor-pointer">{starElements}</div>
  );
};


const StarRating = ({
  rating = 0,
  hoverValue = 0,          // controlled hover state
  onHoverChange,           // parent setter for hover
  onRatingChange,          // parent setter for rating
  maxStars = 5,
  maxRating = 5,
  reviewsCount,
  size = 16,
  interactive = true,      // allow turning hover/click off
}) => {

  // What should be visually displayed
  const displayValue = React.useMemo(() => {
    return hoverValue > 0 ? hoverValue : rating;
  }, [hoverValue, rating]);

  const getFillPercent = (index) => {
    const fillPerStar = maxRating / maxStars;
    const valueForThisStar = (index + 1) * fillPerStar;

    const fill = Math.min(
      Math.max(displayValue - (valueForThisStar - fillPerStar), 0),
      fillPerStar
    );

    return (fill / fillPerStar) * 100;
  };

  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: maxStars }).map((_, index) => {
        const fillPercent = getFillPercent(index);
        const value = index + 1;

        return (
          <svg
            key={index}
            className={`transition-transform duration-150 ${
              interactive ? "cursor-pointer hover:scale-110" : ""
            }`}
            width={size}
            height={size}
            viewBox="0 0 20 20"
            onMouseEnter={() => interactive && onHoverChange?.(value)}
            onMouseLeave={() => interactive && onHoverChange?.(0)}
            onClick={() => interactive && onRatingChange?.(value)}
          >
            <defs>
              <linearGradient id={`grad-${index}`}>
                <stop offset={`${fillPercent}%`} stopColor="#fbbc04" />
                <stop offset={`${fillPercent}%`} stopColor="#edeff2" />
              </linearGradient>
            </defs>
            <path
              fill={`url(#grad-${index})`}
              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.955a1 1 0 00.95.69h4.163c.969 0 
              1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.955c.3.921-.755 
              1.688-1.54 1.118l-3.37-2.448a1 1 0 00-1.175 0l-3.37 2.448c-.785.57-1.84-.197-1.54-1.118l1.287-3.955a1 
              1 0 00-.364-1.118L2.07 9.382c-.783-.57-.38-1.81.588-1.81h4.163a1 1 
              0 00.95-.69l1.286-3.955z"
            />
          </svg>
        );
      })}

      {/* Rating number */}
      <span className="text-16x font-semibold" style={{ color:"#fbbc04" }}>
        {displayValue}
      </span>

      {/* Reviews */}
      {reviewsCount && reviewsCount > 0 && (
        <span className="text-16x text-shadow-forge-700 font-normal">
          ( {t(reviewsCount) + "+ reviews"} )
        </span>
      )}
    </div>
  );
};

export {StarRating}

export default OrderStarRating;
